import { FC } from 'react';
import useRedirectToAndroidApp from '../../hooks/useRedirectToAndroidApp';
import { Button } from '@ordr-as/umami-react/button';

const SoftpayCallbackAndroid: FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const softpayAppId = urlParams.get('appId');
  const redirect = useRedirectToAndroidApp();

  const openAndroidApp = () => {
    redirect.redirectToAndroid(softpayAppId ?? '');
  };

  if (softpayAppId) {
    return (
      <div className="flex flex-col items-center gap-2 mt-4">
        <h1>Softpay connected</h1>
        <p>App id: {softpayAppId}</p>
        <Button kind="primary" onClick={openAndroidApp}>
          Open Android App
        </Button>
      </div>
    );
  }

  return (
    <div>
      <h1>Softpay connection failed</h1>
      {urlParams.toString()}
    </div>
  );
};

export default SoftpayCallbackAndroid;
